module.exports = {"130322100":"昌黎镇","130322101":"靖安镇","130322102":"安山镇","130322103":"龙家店镇","130322104":"泥井镇","130322105":"大蒲河镇","130322106":"新集镇","130322107":"刘台庄镇","130322108":"茹荷镇","130322109":"朱各庄镇","130322110":"荒佃庄镇","130322201":"团林乡","130322202":"葛条港乡","130322203":"马坨店乡","130322206":"两山乡","130322207":"十里铺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130322.json
// module id = 190
// module chunks = 0